import { ButtonColor, ButtonSize, ButtonWithOptions, Spinner } from "@swivl-mono/ui";
import { Link } from "react-router-dom";
import { BlankState, MenuOption, TitleForMenuOption } from "../BotAnalyticsDashboard";
import { groupByLocationId, ProfileCollectDataForType } from "../Helpers/DataHelpers";

export const ProfileCollect = ({ profileData, profileMenu, onMenuChange, renderTotalsAndChart, startDay, endDay }) => {

  const isLoading = !profileData || !profileData.total;
  const isEmpty = !isLoading && !profileData.total.total;

  if (isLoading || isEmpty) {
    return (
      <div className="chartBox">
        <div className="chartHeader">
          <div className="chartHeaderTitle">
            <span>Contact Info Collected</span>
          </div>
          <div className="spacer" />
        </div>
        <div className="chartContent">
          <div className="loadingContent">{isLoading ? <Spinner /> : BlankState()}</div>
        </div>
      </div>
    );
  }

  const data = ProfileCollectDataForType(profileData, profileMenu);
  const totalCollected = profileData.total.total.toLocaleString();
  const phoneCollected = profileData.total.phoneCollections + profileData.total.cardSavedPhone + profileData.total.cardSavedBoth;
  const emailCollected = profileData.total.emailCollections + profileData.total.cardSavedEmail + profileData.total.cardSavedBoth;

  return (
    <div className="chartBox">
      <div className="chartHeader">
        <div className="chartHeaderTitle">
          <span>Contact Info Collected by </span>
          <ButtonWithOptions
            color={ButtonColor.WHITE}
            size={ButtonSize.SMALL}
            buttonOptions={[
              { title: "Day", name: "Day", onClick: () => onMenuChange("profileMenu", "Day") },
              { title: "Time of Day", name: "TimeOfDay", onClick: () => onMenuChange("profileMenu", "TimeOfDay") },
              { title: "Day of Week", name: "DayOfWeek", onClick: () => onMenuChange("profileMenu", "DayOfWeek") },
            ]}
          >
            {TitleForMenuOption(profileMenu)}
          </ButtonWithOptions>
        </div>
        <Link to={`/analytics/crm/${startDay}/${endDay}`} className="viewAll">VIEW ALL</Link>
        <div className="spacer" />
        <div className="chartKey">
          <div className="chartKeyItem">
            <span className="chartKeyBox" style={{ background: "#FF5C02" }} /> Phone
          </div>
          <div className="chartKeyItem">
            <span className="chartKeyBox" style={{ background: "#FFA900" }} /> Email
          </div>
        </div>
      </div>
      <div className="chartContent">
        {renderTotalsAndChart(totalCollected, phoneCollected, emailCollected, "TOTAL", "PHONE", "EMAIL", ["#FF5C02", "#FFA900"], profileMenu === MenuOption.TimeOfDay, data)}
      </div>
    </div>
  );
};
